export default __webpack_public_path__ + "static/media/09-piano.5684b2da.svg";